// extracted by mini-css-extract-plugin
module.exports = {"root":"AppFooter_root__3SvOS","copyright":"AppFooter_copyright__pwVBx"};